import gsap from "gsap";
import { symbols } from "../configs/symbols.config.js";

const HIGH_VALUE_SYMBOLS = symbols.filter((s) => s.name.startsWith("H")).map((s) => s.name);

/**
 * Triggers character reaction animation on win with high-value symbols.
 * Randomly picks girl or man side, plays Spine idle + shine overlay.
 */
export function characterReaction(bgScene, { winnerSymbol } = {}) {
    const tl = gsap.timeline();

    if (!HIGH_VALUE_SYMBOLS.includes(winnerSymbol)) return tl;

    const side = Math.random() >= 0.5 ? "girl" : "man";
    tl.add(() => bgScene.playCharacterReaction(side));

    return tl;
}
